'use strict';

var dateFnsTz = require('date-fns-tz');
var models = require('../models.cjs');

const ISO_DAY_OF_WEEK_MAP = {
  1: models.DayOfWeek.Mon,
  2: models.DayOfWeek.Tue,
  3: models.DayOfWeek.Wed,
  4: models.DayOfWeek.Thu,
  5: models.DayOfWeek.Fri,
  6: models.DayOfWeek.Sat,
  7: models.DayOfWeek.Sun
};
const getDayOfWeek = ({ timeZone, date }) => {
  const isoDayOfWeek = Number(dateFnsTz.formatInTimeZone(date, timeZone, "i"));
  return ISO_DAY_OF_WEEK_MAP[isoDayOfWeek];
};

module.exports = getDayOfWeek;
//# sourceMappingURL=getDayOfWeek.cjs.map
